export const euro = [
  {
    number: 'EC100',
    hasModel: false
  },
  {
    number: 'EC101',
    hasModel: false
  },
  {
    number: 'EC102',
    hasModel: false
  },
  {
    number: 'EC103',
    hasModel: false
  },
  {
    number: 'EC104',
    hasModel: false
  },
  {
    number: 'EC105',
    hasModel: false
  },
  {
    number: 'EC106',
    hasModel: false
  },
  {
    number: 'EC107',
    hasModel: false
  },
  {
    number: 'EC108',
    hasModel: false
  },
  {
    number: 'EC109',
    hasModel: false
  },
  {
    number: 'EC110',
    hasModel: false
  },
  {
    number: 'EC111',
    hasModel: false
  },
  {
    number: 'EC112',
    hasModel: false
  },
  {
    number: 'EC113',
    hasModel: false
  },
  {
    number: 'EC114',
    hasModel: false
  },
  {
    number: 'EC115',
    hasModel: false
  },
  {
    number: 'EC116',
    hasModel: false
  },
  {
    number: 'EC117',
    hasModel: false
  },

]